import React from 'react';

import BEM from '@scripts/utilities/bem.js';
import { currencyFormatter } from '@scripts/utilities/numbers.js';

import DonutChart from '../../DonutChart/index.jsx';


class CategoryBreakdown extends React.Component {
  constructor(props) {
    super(props);

    this.setChartOptions = this.setChartOptions.bind(this);
  }

  portfolioMap(item) {
    return {
      name: item.asset.category,
      value: item.value
    };
  }

  portfolioReduce(result, item) {
    var found = false;
    for (var i = 0; i < result.length; i++) {
      if (result[i].name == item.name) {
        result[i].value += item.value;
        found = true;
        break;
      }
    }

    if (! found) {
      result.push(item);
    }

    return result;
  }

  tooltipFormatter(params) {
    return params.name + ': <strong>' + currencyFormatter.format(params.value) +
      '</strong> (' + params.percent + '%)';
  }

  setChartOptions(options) {
    options.tooltip.formatter = this.tooltipFormatter;

    options.series[0].label = {
      show: true,
      position: 'inside',
      fontWeight: 'bold'
    };

    return options;
  }

  render() {
    var content = null;

    if (this.props.portfolio) {
      var chartData = this.props.portfolio
        .map(this.portfolioMap)
        .reduce(this.portfolioReduce, []);

      if (chartData.length) {
        content = (
          <React.Fragment>
            <div className={BEM.classString('cs-block-asset-chart', 'align-narrow') + ' mb-2'}>
              <DonutChart
                chartData={chartData}
                showLegend={false}
                setChartOptions={this.setChartOptions}
              />
            </div>
            <p className="text-center"><strong>Breakdown by Asset Category (USD)</strong></p>
          </React.Fragment>
        );
      }
    }


    return content;
  }
}


export default CategoryBreakdown;

